import { render } from "./saves.vue?vue&type=template&id=327ac6fa&scoped=true"
import script from "./saves.vue?vue&type=script&lang=js"
export * from "./saves.vue?vue&type=script&lang=js"

import "./saves.vue?vue&type=style&index=0&id=327ac6fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327ac6fa"]])

export default __exports__